import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["selectAll", "rowCheckbox", "selectedIds", "selectedPanel", "count", "actionSelect", "priceField", "copyField", "previewText"];
  static values = { previewUrl: String };

  connect() {
    this.actionChanged();
    this.selectionChanged();
  }

  actionChanged() {
    if (!this.hasActionSelectTarget) return;

    const action = this.actionSelectTarget.value;
    const showPrice = action === "update_price";
    const showCopy = action === "copy_slots";
    this.priceFieldTarget.classList.toggle("hidden", !showPrice);
    this.copyFieldTarget.classList.toggle("hidden", !showCopy);
    this.priceFieldTarget.querySelector("input").required = showPrice;
    this.copyFieldTarget.querySelector("input").required = showCopy;
  }

  toggleAll() {
    this.rowCheckboxTargets.forEach((checkbox) => { checkbox.checked = this.selectAllTarget.checked; });
    this.selectionChanged();
  }

  selectionChanged() {
    if (!this.hasSelectedIdsTarget) return;

    const checked = this.rowCheckboxTargets.filter((checkbox) => checkbox.checked);
    this.selectedIdsTarget.value = checked.map((checkbox) => checkbox.value).join(",");
    this.countTarget.textContent = checked.length;
    this.selectedPanelTarget.classList.toggle("hidden", checked.length === 0);
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = this.rowCheckboxTargets.length > 0 && checked.length === this.rowCheckboxTargets.length;
      this.selectAllTarget.indeterminate = checked.length > 0 && checked.length < this.rowCheckboxTargets.length;
    }
  }

  clearSelection() {
    this.rowCheckboxTargets.forEach((checkbox) => { checkbox.checked = false; });
    this.selectionChanged();
  }

  async preview(event) {
    const form = event.currentTarget.closest("form");
    const data = Object.fromEntries(new FormData(form).entries());
    if (!data.batch_action || !data.start_date || !data.end_date) {
      this.previewTextTarget.textContent = "请选择日期范围和操作";
      return;
    }

    this.previewTextTarget.textContent = "正在计算影响范围…";
    try {
      const response = await fetch(this.previewUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
        },
        body: JSON.stringify(data)
      });
      if (!response.ok) throw new Error(`Preview failed: ${response.status}`);
      const result = await response.json();
      this.previewTextTarget.textContent = `将影响 ${result.count} 个时间段`;
    } catch (_error) {
      this.previewTextTarget.textContent = "预览失败，请稍后重试";
    }
  }
}
